import React from 'react'
import {userSelectors} from '../../../store/user/userSelectors'
import {cx} from '../../../utils/classNameUtil'
import {ProductSwitcherMenuItem} from './menu-item/ProductSwitcherMenuItem'
import styles from './ProductSwitcher.module.scss'

interface IProductSwitcherProps {
  isOpen: boolean
}

export const ProductSwitcher = ({
  isOpen,
}: IProductSwitcherProps): React.JSX.Element => {
  const productSwitcher = userSelectors.useProductSwitcher()

  return (
    <ul
      className={cx(
        styles.productSwitcher,
        isOpen && styles.productSwitcherOpen,
      )}
    >
      {productSwitcher?.map((menuItem, index: number) => {
        return <ProductSwitcherMenuItem menuItem={menuItem} key={index} />
      })}
    </ul>
  )
}
